export const scrollToTop = () => {
    const btn = document.getElementById('scroll-to-top-js');

    if (!btn) return;

    const toggleButton = () => {
        if (window.scrollY > window.innerHeight) {
            btn.classList.remove('hidden');
        } else {
            btn.classList.add('hidden');
        }
    };

    btn.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });

    window.addEventListener('scroll', toggleButton);
    toggleButton();
};